import styled from "styled-components";
import { Button as ButtonAntd } from "antd";

const FlipButton = styled.img`
  position: absolute;
  top: 1.125rem;
  right: 1.25rem;
  opacity: 0.55;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

const Beta = styled.img`
  position: absolute;
  height: 54px;
  top: 0;
  left: 0;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 100%;
`;

const Icon = styled.img`
  height: ${({ height }) => height || 64}px;
`;

const Title = styled.h5`
  margin: 0.5rem 0;
  text-align: center;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.4;
`;

const Description = styled.span`
  margin-top: 1rem;
  text-align: center;
  font-size: 0.75rem;
`;

const Button = styled(ButtonAntd)`
  width: 150px;
  text-transform: uppercase;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.light};
  background-color: #1890ff;
  border: 0;
`;

const ButtonArrow = styled(ButtonAntd)`
  float: right;
  color: ${({ theme }) => theme.colors.dark};
`;

const Flipper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
  width: 100%;
  min-height: 260px;
  height: 100%;
  margin-bottom: 1rem;
  padding: 2rem 1.5rem;
  background-color: ${({ theme }) => theme.colors.light};
  border-radius: 0.5rem;
  overflow: hidden;
  transition: height 0.3s ease-in-out;
`;

export default {
  Beta,
  Button,
  ButtonArrow,
  Container,
  Description,
  Flipper,
  FlipButton,
  Icon,
  Title,
};
